import { useParams } from 'react-router-dom';
import Category from '../../components/Landing/ExploreByCategory';
import Footer from '../../components/Landing/Footer';
import GetApp from '../../components/Landing/GetApp';
import LandingMain from '../../components/Landing/LandingMain';
import TopSubjects from '../../components/Landing/TopSubjects';
import PageNotFound from '../404';
import { SEO } from '../../components/SEO';

export default function ExploreTutorByType() {
  let { type } = useParams();

  const typeTitle = type === 'subject' ? 'Subjects' : type === 'hobby' ? 'Hobbies' : type === 'skill' ? 'Skills' : '';

  if (type !== 'subject' && type !== 'hobby' && type !== 'skill') {
    return <PageNotFound />;
  }

  return (
    <>
    <SEO 
      title={`Browse Tutors by ${typeTitle}`}
      description={`Explore expert tutors specializing in ${typeTitle.toLowerCase()}. Find the perfect tutor for your learning needs.`}
      keywords={`tutors, ${typeTitle.toLowerCase()} tutors, online ${typeTitle.toLowerCase()} tutoring, find tutor by ${typeTitle.toLowerCase()}`}
      url={`/explore/${type}`}
      type="website"
      og={{
        type: 'website',
        siteName: 'WorldoTutor',
        locale: 'en_US',
        image: {
          url: '/imgi_1_favicon.png',
          alt: `Browse Tutors by ${typeTitle} - WorldoTutor`,
          width: 1200,
          height: 630
        }
      }}
      twitter={{
        card: 'summary_large_image',
        site: '@worldotutor',
        image: {
          url: '/imgi_1_favicon.png',
          alt: `Browse Tutors by ${typeTitle} - WorldoTutor`
        }
      }}
    />
    <div>
      <div className="bg-primary">
        <LandingMain
          title={`Explore the tutors by ${
            type == 'subject' ? 'Subjects' : type === 'hobby' ? 'Hobbies' : type === 'skill' ? 'Skill Developement' : ''
          }`}
          searchBox={false}
        />
      </div>
      <div>
        <div className="bg-[#F5F6F9]">
          <div className=" w-10/12 mx-auto">
            {/* @ts-ignore */}
            <Category title={type} type={type!} button={false} />
          </div>
        </div>
        <div className="bg-neutralBlue2">
          <GetApp />
        </div>
        <div className="bg-white">
          <TopSubjects />
        </div>
        <div className="bg-neutralBlack">
          <Footer />
        </div>
      </div>
    </div>
    </>
  );
}
